import { render } from "./SuperadminDashboard.vue?vue&type=template&id=c05751d8&ts=true"
import script from "./SuperadminDashboard.vue?vue&type=script&lang=ts"
export * from "./SuperadminDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__